var React = require('react');

function TickRound (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"9","cy":"9","r":"8.5","stroke":"#676D73","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.4592 6.54048C12.7131 6.79432 12.7131 7.20588 12.4592 7.45972L8.45923 11.4597C8.20539 11.7136 7.79383 11.7136 7.53999 11.4597L5.53999 9.45972C5.28615 9.20588 5.28615 8.79432 5.53999 8.54048C5.79383 8.28664 6.20539 8.28664 6.45923 8.54048L7.99961 10.0809L11.54 6.54048C11.7938 6.28664 12.2054 6.28664 12.4592 6.54048Z","fill":"#676D73","key":1})]);
}

TickRound.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = TickRound;

TickRound.default = TickRound;
